module.exports = __webpack_public_path__ + "img/img-card-3.105feec.webp";